import React from 'react'
import { Restaurant } from '../../../interfaces/Catalogue';
import { UserInfo } from '../../../interfaces/user';
import { LoyaltyArticle } from '../../../interfaces/loyality.interface';
import { useConfig } from '../../../context/ConfigContext';
import SectionHeader from './SectionHeader/SectionHeader';

import './ArticlesDiscountSection.scss';
import { LoyaltyArticlesList } from './LoyaltyArticlesList/LoyaltyArticlesList';

interface ArticlesDiscountSectionProps {
  restaurant: Restaurant;
  userInfo?: UserInfo;
  loyaltyArticles: LoyaltyArticle[];
  currentUserPoints: number;
  maxPoints: number;
  userProgress: number;
  missingPoints: number;
  onPressViewAll: () => void;
}

const ArticlesDiscountSection: React.FC<ArticlesDiscountSectionProps> = ({
  restaurant,
  userInfo,
  loyaltyArticles,
  currentUserPoints,
  maxPoints,
  userProgress,
  missingPoints,
  onPressViewAll,
}) => {
  const { config } = useConfig();
  const primaryColor = config?.primaryColor || '#6366F1';

  const renderProgressDots = () => {
    const dots = [];
    const dotCount = 5;

    for (let i = 0; i < dotCount; i++) {
      const position = (i / (dotCount - 1)) * 100;
      dots.push(
        <div
          key={i}
          className="dot-container"
          style={{ left: `${position}%` }}
        >
          <div className="dot" />
        </div>
      );
    }

    return <div className="progress-dots">{dots}</div>;
  };

  const nextLockedArticle = loyaltyArticles.find(article => article.isLocked);

  return (
    <div className="articles-discount-container">
      <div className="discount-section">
        <div
          className="progress-card"
          style={{ borderColor: primaryColor + '20' }}
        >
          <div className="progress-card-header">
            <div
              className="progress-icon-container"
              style={{ backgroundColor: primaryColor + '15' }}
            >
              <span
                className="progress-icon"
                style={{ color: primaryColor }}
              >
                🏆
              </span>
            </div>
            <div className="progress-text-container">
              <div className="progress-card-title">Votre progression</div>
              <div className="progress-card-subtitle">
                {currentUserPoints} points collectés
              </div>
            </div>
            <button
              className="progress-view-all-button"
              style={{ backgroundColor: primaryColor + '22' }}
              onClick={onPressViewAll}
            >
              <span className="chevron-icon-progress" >
                ›
              </span>
            </button>
          </div>

          {maxPoints > 0 && (
            <div className="progress-wrapper">
              <div className="progress-bg">
                <div
                  className="progress-bar"
                  style={{
                    width: `${userProgress}%`,
                    background: `linear-gradient(90deg, ${primaryColor}, ${primaryColor}CC)`
                  }}
                />
                {renderProgressDots()}
              </div>

              <div className="progress-info-row">
                <div className="progress-percentage-text">
                  {Math.round(userProgress)}% complété
                </div>
                {missingPoints > 0 && (
                  <div
                    className="missing-points-badge"
                    style={{ backgroundColor: primaryColor + '10' }}
                  >
                    <span
                      className="stars-icon"
                      style={{ color: primaryColor }}
                    >
                      ⭐
                    </span>
                    <span
                      className="missing-points-text"
                      style={{ color: primaryColor }}
                    >
                      {missingPoints} pts manquants
                    </span>
                  </div>
                )}
              </div>
            </div>
          )}

          {nextLockedArticle && (
            <div className="next-reward-preview">
              <div className="next-reward-label">Prochaine récompense</div>
              <div className="next-reward-item">
                <div className="next-reward-name">
                  {nextLockedArticle.name}
                </div>
                <div
                  className="next-reward-badge"
                  style={{ backgroundColor: primaryColor }}
                >
                  <span className="next-reward-points">
                    {nextLockedArticle.pointsRequired} pts
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>


    </div>
  );
};

export default ArticlesDiscountSection;